document.addEventListener("DOMContentLoaded", () => {
	let intervalID = null;
	const intervalManager = (flag, func, interval) => {
		if (flag) {
			intervalID = setInterval(func, interval);
		} else {
			clearInterval(intervalID);
		}
	};

	let idx = 0;
	const animate = () => {
		idx += 1;

		if (idx > 8) {
			intervalManager(false);
			setTimeout(() => {
				document.querySelectorAll(".steps svg path").forEach((item) => item.classList.remove("visible"));
				idx = 0;
				intervalManager(true, animate, 800);
			}, 5000);
		}

		document.querySelector(`.steps svg #step${idx}`).classList.add("visible");
	};

	if (document.querySelector(".steps")) {
		intervalManager(true, animate, 800);
	}
});
